<!-- Use preprocessors via the lang attribute! e.g. <template lang="pug"> -->
<template>
    <div :class="{'d-flex': modelObjPath}">
        <div class="upper-buttons d-flex align-items-center justify-content-center">
            <div class="zoom-buttons-block"
                v-if="modelObjPath">
                <div class="zoom-buttons-plus"
                     @click="zoomCamera">
                    <span class="tooltip-block">Zoom in</span>
                </div>
                <div class="zoom-buttons-minus" @click="zoomOutCamera">
                    <span class="tooltip-block">Zoom out</span>
                </div>
            </div>
        </div>
        <div class="position-relative">
            <div class="progressbar" :style="progressBarShow"></div>
            <canvas class="three-canvas" :id="this.uniqueIndeficator"></canvas>
            <div v-if="!modelObjPath"
                class="absolute-text-on-canvas">
                <p>Your model is not yet calculated. Set the settings and click the "Calculate Model Price" button.</p>
            </div>
            <div class="buttons-block"
                v-if="modelObjPath">
                <div
                    class="rotation-toggle-block"
                    @click="triggerRotation"
                    :class="{'rotation-toggle-block-disabled': this.cameraRotationFlag !== true}">
                    <span class="tooltip-block">Stop/start rotation</span>
                </div>
                <div class="reset-view-block" @click="resetView">
                    <span class="tooltip-block">Reset view</span>
                </div>
            </div>
        </div>
        <div>
        </div>
    </div>
</template>
<script>
import * as THREE from 'three'
import {GLTFLoader} from 'three/addons/loaders/GLTFLoader.js';
import {OrbitControls} from 'three/addons/controls/OrbitControls.js';
import {Vector3} from "three";

export default {
    data() {
        return {
            fileInfo: null,
            model: null,
            progress: 5,
            cameraPositionX: 700,
            cameraPositionY: 800,
            cameraPositionZ: 400,
            cameraRotationFlag: true,
            autoRotateSpeed: -1,
        };
    },
    props: {
        modelColor: {
            type: String,
            // required: true
        },
        uniqueIndeficator: {
            type: String,
            required: true
        },

        modelObjPath: {
            type: String,
            required: true
        },
    },
    mounted() {
        this.loadScene();
    },

    methods: {

        animate() {
            this.controls.update();
            this.renderer.render(this.scene, this.camera);
            requestAnimationFrame(this.animate);
        },
        zoomCamera() {
            let vm = this;
            if (vm.camera.position.z > 0) {
                vm.camera.position.z -= 40;
            } else {
                vm.camera.position.z += 40;
            }
            if (vm.camera.position.y > 0) {
                vm.camera.position.y -= 40;
            } else {
                vm.camera.position.y += 40;
            }
            if (vm.camera.position.x > 0) {
                vm.camera.position.x -= 40;
            } else {
                vm.camera.position.x += 40;
            }
        },
        zoomOutCamera() {
            let vm = this;
            if (vm.camera.position.z > 0) {
                vm.camera.position.z += 40;
            } else {
                vm.camera.position.z -= 40;
            }
            if (vm.camera.position.y > 0) {
                vm.camera.position.y += 40;
            } else {
                vm.camera.position.y -= 40;
            }
            if (vm.camera.position.x > 0) {
                vm.camera.position.x += 40;
            } else {
                vm.camera.position.x -= 40;
            }

        },
        resetView() {
            let vm = this;
            vm.controls.reset();
        },
        triggerRotation() {

            let vm = this;
            vm.cameraRotationFlag = !vm.cameraRotationFlag;
            if (vm.cameraRotationFlag) {
                this.controls.autoRotateSpeed = vm.autoRotateSpeed;
            } else {
                this.controls.autoRotateSpeed = 0;
            }
            vm.controls.update()
        },
        loadScene() {

            let vm = this;
            this.scene = new THREE.Scene();
            let windowWidth = window.innerWidth;
            let frameSize = 600;
            if (windowWidth < 1410) {
                frameSize = 550
            }
            if (windowWidth < 650) {
                frameSize = 500
            }
            if (windowWidth < 500) {
                frameSize = 400
            }
            const size = {
                width: frameSize,
                height: frameSize,
            };

            const aspect = size.width / size.height;
            this.camera = new THREE.PerspectiveCamera(12, aspect);
            this.camera.position.z = vm.cameraPositionZ;
            this.camera.position.y = vm.cameraPositionY;
            this.camera.position.x = vm.cameraPositionX;

            const lightColor = 0xffffff;

            const ambientLight = new THREE.AmbientLight(lightColor, 0.5);
            this.scene.add(ambientLight);

            const directionalLight = new THREE.DirectionalLight(lightColor, 1);
            directionalLight.position.set(0, 10, 0);
            directionalLight.target.position.set(-5, 0, 0);
            this.scene.add(directionalLight);
            this.scene.add(directionalLight.target);
            this.scene.background = new THREE.Color(0xfcfbfb);

            const grid = new THREE.GridHelper(800, 20);
            this.scene.add(grid);

            const threeCanvas = document.getElementById(vm.uniqueIndeficator);

            if (threeCanvas) {
                this.renderer = new THREE.WebGLRenderer({
                    canvas: threeCanvas,
                    alpha: true,
                });
                this.renderer.setSize(size.width, size.height);
                this.renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
                this.controls = new OrbitControls(this.camera, threeCanvas);
                this.controls.enableDamping = true;
                this.controls.enabled = true;
                this.controls.autoRotate = vm.cameraRotationFlag;
                this.controls.autoRotateSpeed = vm.autoRotateSpeed;
                this.controls.target.set(0, 0.2, 0);
                this.controls.maxDistance = 1900;
                this.controls.minDistance = 60;

                this.loader = new GLTFLoader().setPath(window.location.origin);
                this.loader.load(vm.modelObjPath,
                    function (gltf) {

                        const addedModel = gltf.scene;
                        vm.model = addedModel;
                        let box = new THREE.Box3().setFromObject(addedModel);
                        let center = new THREE.Vector3();
                        box.getCenter(center);
                        addedModel.position.sub(center); // center the model
                        addedModel.position.y = 0
                        vm.scene.add(addedModel);
                        // camera.lookAt(addedModel.clientX,addedModel.clientY,0)


                        // Set the color of the model
                        const color = new THREE.Color(vm.modelColor); // red color
                        addedModel.traverse((child) => {
                            if (child.isMesh) {
                                child.material.color = color;
                            }
                        });
                    },
                    (xhr) => {
                        vm.progress = Math.ceil((xhr.loaded / xhr.total) * 100);
                        // console.log((xhr.loaded / xhr.total) * 100 + '% loaded')
                        if (vm.progress === 100) {
                            vm.progress = 0;
                        }
                    },
                    (error) => {
                        console.log(error);
                    }
                )
                this.animate();
            }
        },
        changeModelColor(color) {
            let vm = this;
            if (color === '#000000') { // replace absolute black to grafite
                color = '#24282b';
            }

            const colorTree = new THREE.Color(color); // red color
            vm.model.traverse((child) => {
                if (child.isMesh) {
                    child.material.color = colorTree;
                }
            });
            // vm.renderScene();
        },
        changeFilePath(newModelObjPath) {
        }
    },
    watch: {
        modelColor(newColor, oldColor) {
            this.changeModelColor(newColor);
        },
        modelObjPath(newModelObjPath, oldModelObjPath) {
            this.changeFilePath(newModelObjPath)
        },
    },

    computed: {
        progressBarShow() {
            return {
                width: `${this.progress}%`
            };
        }
    }
};
</script>

<!-- Use preprocessors via the lang attribute! e.g. <style lang="scss"> -->
<style scoped>

.progressbar {
    position: relative;
    height: 5px;
    background: #5644c9;
    overflow: hidden;
}

.three-canvas {
    cursor: grab;
    border-radius: 30px;
}
.absolute-text-on-canvas {
    background-color: #F5F1FF;
    text-align: center;
    top: 50%;
    position: absolute;
}

.zoom-buttons-block {
    background-image: url('/images/3d-nav-buttons/vertical.svg');
    height: 144px;
    width: 72px;
    background-repeat: no-repeat;
    /*position: absolute;*/
    /*top: 50%;*/
    scale: 0.8;

}

.zoom-buttons-plus {
    background-image: url('/images/3d-nav-buttons/zoom_in.svg');
    height: 72px;
    width: 72px;
    background-repeat: no-repeat;
    cursor: pointer;
}

.tooltip-block {
    visibility: hidden;
    width: 120px;
    border-radius: 8px;
    background: var(--fill-color-white, #FFF);
    padding: 5px 0;
    color: var(--gray-700, #344054);
    text-align: center;
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: 18px; /* 100% */

    /* Position the tooltip */
    position: absolute;
    left: 90px;
    top: 20px;
    z-index: 1;
}

.zoom-buttons-plus:hover .tooltip-block {
    visibility: visible;
}

.zoom-buttons-minus:hover .tooltip-block {
    top: 100px;
    visibility: visible;
}

.rotation-toggle-block:hover .tooltip-block {
    width: 250px;
    top: 20px;
    left:180px;
    visibility: visible;
}
.reset-view-block:hover .tooltip-block {
    width: 150px;
    top: 20px;
    left:-150px;
    visibility: visible;
}

.zoom-buttons-plus:hover {
    background-image: url('/images/3d-nav-buttons/zoom_in_hover.svg');
}

.zoom-buttons-minus {
    background-image: url('/images/3d-nav-buttons/zoom_out.svg');
    height: 72px;
    width: 72px;
    background-repeat: no-repeat;
    cursor: pointer;
    /*z-index: 1;*/

}

.zoom-buttons-minus:hover {
    background-image: url('/images/3d-nav-buttons/zoom_out_hover.svg');
}

.rotation-toggle-block {
    background-image: url('/images/3d-nav-buttons/rotation_toggle_on.svg');
    height: 72px;
    width: 174px;
    background-repeat: no-repeat;
    /*position: absolute;*/
    /*top: 70%;*/
    /*z-index: 1;*/
    cursor: pointer;
    scale: 0.8;
}

.rotation-toggle-block-disabled {
    background-image: url('/images/3d-nav-buttons/rotation_toggle_off.svg');
}

.reset-view-block {
    background-image: url('/images/3d-nav-buttons/reset.svg');
    height: 72px;
    width: 72px;
    background-repeat: no-repeat;
    /*position: absolute;*/
    /*z-index: 1;*/
    cursor: pointer;
    scale: 0.8;

}

.reset-view-block:hover {
    background-image: url('/images/3d-nav-buttons/reset_hover.svg');
}

.buttons-block {
    /*position: absolute;*/
    width: 100%;
    /*height: 100%;*/
    display: flex;
    justify-content: space-between;
    align-items: end;
    margin-top: -77px;

}

.upper-buttons {
    margin-right: -77px;
    z-index: 1;
}
</style>
